export function normalizeTypes(code = '') {
    return code
        .replace(/varchar\(max\)/gi, 'long varchar')
        .replace(/nvarchar\(max\)/gi, 'long nvarchar')
        .replace(/varbinary\(max\)/gi, 'long binary');
}

export function compareSqlAndSybase(sqlCode = '', sybaseCode = '') {
    if (!sqlCode && !sybaseCode) return 1;

    const normalizedSql = normalizeTypes(sqlCode);

    if (sqlCode === sybaseCode) return 1;
    if (normalizedSql === sybaseCode) return 2;

    return 3;
}
